export const sum = (a, b) => a + b;

const getMinutes = activity => {
    return activity && activity.minutes ? activity.minutes : 0;
};

export const totalMinutes = activities => {
    if (!activities) return 0;
    return activities.map(getMinutes).reduce(sum, 0);
};

export const convertToHours = minutes => {
    return Math.round(minutes / 60 * 100) / 100;
};

export const totalHours = activities => {
    return convertToHours(totalMinutes(activities));
};

export const prettyTimeSumString = activities => {
    const tMinutes = totalMinutes(activities);
    return prettyTimeString(tMinutes);
};

export const prettyTimeString = tMinutes => {
    if (!tMinutes || tMinutes <= 0) return '0m';

    const hours = Math.floor(tMinutes / 60);
    const minutes = tMinutes - hours * 60;
    const h = hours > 0 ? `${hours}h` : '';
    const m = minutes > 0 ? `${minutes}m` : '';
    const space = h && m ? ' ' : '';

    return `${h}${space}${m}`;
};

export const timeString = (date, locale) => {
    if (!date) return '';
    const options = {hour: '2-digit', minute: '2-digit'};
    return new Date(date).toLocaleTimeString(locale, options);
}

export const diffInMinutes = (date1, date2) => {
    if (!date1 || !date2) return 0;

    const d1 = new Date(date1);
    const d2 = new Date(date2);

    return Math.ceil((d2 - d1) / (1000 * 60));
}

export const activityString = record => `${record.shortName} - ${prettyTimeString(record.minutes)}`;
